var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "flex-level" },
    [
      _vm.item.isSellsy
        ? _c("CompassLogo", { attrs: { theme: "light", width: 24 } })
        : _vm.item.compassicon
        ? _c("CompassIcon", {
            attrs: { icon: _vm.item.compassicon, size: "large" }
          })
        : _vm.item["fa"]
        ? _c("i", { class: "fa " + _vm.item["fa"] })
        : _vm.item["icon"]
        ? _c(
            "icon-svg",
            {
              attrs: {
                "view-box": "0 0 26 26",
                width: 26,
                height: 26,
                iconName: _vm.item["icon"]
              }
            },
            [_c(_vm.icon, { tag: "component" })],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.item["hasSecondIcon"]
        ? _c(
            "span",
            {
              staticClass: "external-chip flex-level ml-2 external-chip__icon"
            },
            [_c("i", { staticClass: "icon-plus white" })]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("span", { staticClass: "menu--label flex-level" }, [
        _vm._v(
          "\n        " +
            _vm._s(_vm.item["txt"] ? _vm.item["txt"] : "") +
            "\n        "
        ),
        _vm.item["hasSecondIcon"]
          ? _c(
              "span",
              {
                staticClass:
                  "external-chip flex-level ml-2 external-chip__icon-with-text"
              },
              [_c("i", { staticClass: "icon-plus white" })]
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }